'use strict';

angular.module('internal.applications')
    .controller('InternalApplicationDeleteModal', ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        $scope.vm = {
            reason: null
        }

        $scope.yes = function () {
            $uibModalInstance.close($scope.vm.reason);
        }

        $scope.no = function () {
            $uibModalInstance.close(null);
        }
    }])
;